import React, { useState, useEffect } from "react";
import moment from 'moment';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import toast from "react-hot-toast";
import RSelect from "../select/ReactSelect";

const AddWorkflowModal = ({ showWorkflowModal, setShowWorkflowModal, modalType, selectedRow, getAllWorkflows }) => {
    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const selectedBranch = JSON.parse(localStorage.getItem('selected_branch'));

    const [workflowName, setWorkflowName] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (showWorkflowModal && selectedBranch) {
            fetchCategories();
        }
    }, [showWorkflowModal]);

    // Pre-populate fields when editing
    useEffect(() => {
        if (showWorkflowModal && modalType === 1 && selectedRow) {
            setWorkflowName(selectedRow.name || "");
            if (selectedRow.categories && selectedRow.categories.length > 0) {
                const preSelected = selectedRow.categories.map((cat, index) => ({
                    value: `${cat.id}_${index}`,
                    actualValue: cat.id,
                    label: cat.name
                }));
                setSelectedCategories(preSelected);
            }
        }
    }, [showWorkflowModal, modalType, selectedRow]);

    const fetchCategories = () => {
        setIsLoading(true);
        axios({
            method: 'GET',
            url: `${baseUrl}/counter/get-list/without-category-groups/${selectedBranch.id}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            const list = res.data.data.list || [];
            const options = list.map(item => ({
                value: item.id,
                label: item.category
            }));
            setCategoryOptions(options);
            setIsLoading(false);
        }).catch((error) => {
            console.error("Error fetching categories:", error);
            setIsLoading(false);
        });
    };

    const handleCategoryChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'select-option') {
            const selected = actionMeta.option;
            const newEntry = {
                value: `${selected.value}_${Date.now()}`,
                actualValue: selected.value,
                label: selected.label
            };
            setSelectedCategories([...selectedCategories, newEntry]);
        } else if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
            const removed = actionMeta.removedValue;
            setSelectedCategories(selectedCategories.filter(item => item.value !== removed.value));
        } else if (actionMeta.action === 'clear') {
            setSelectedCategories([]);
        }
    };

    const closeModal = () => {
        setShowWorkflowModal(false);
        setWorkflowName("");
        setSelectedCategories([]);
    };

    const handleAddWorkflow = () => {
        const body = {
            branchId: selectedBranch.id,
            name: workflowName,
            categoryIds: selectedCategories.map(item => item.actualValue || item.value)
        }

        axios({
            method: 'POST',
            url: `${baseUrl}/workflow/add`,
            headers: {
                Authorization: token
            },
            data: body
        }).then((res) => {
            toast.success('Workflow added successfully', { position: 'bottom-center' });
            if (getAllWorkflows) {
                getAllWorkflows();
            }
            closeModal();
        }).catch((error) => {
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
            console.log(error);
        });
    };

    const handleUpdateWorkflow = () => {
        const body = {
            id: selectedRow.id,
            name: workflowName,
            categoryIds: selectedCategories.map(item => item.actualValue || item.value)
        }

        axios({
            method: 'POST',
            url: `${baseUrl}/workflow/update`,
            headers: {
                Authorization: token
            },
            data: body
        }).then((res) => {
            toast.success('Workflow updated successfully', { position: 'bottom-center' });
            if (getAllWorkflows) {
                getAllWorkflows();
            }
            closeModal();
        }).catch((error) => {
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
            console.log(error);
        });
    };

    return (
        <>
            {showWorkflowModal ?
                <div className={`modal fade d-block show modal-container`} id="workflowModal">
                    <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{modalType === 1 ? 'Edit' : 'Add'} Workflow</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={closeModal}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form className='counter-add-form mt-3'>
                                    <Row className="clearfix">
                                        <Col md={12}>
                                            <div className="form-group mb-3">
                                                <label className="form-label">Workflow Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter workflow name"
                                                    value={workflowName}
                                                    onChange={(e) => setWorkflowName(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="form-group mb-3">
                                                <label className="form-label">Select Categories</label>
                                                <RSelect
                                                    options={categoryOptions}
                                                    isMulti
                                                    hideSelectedOptions={false}
                                                    value={selectedCategories}
                                                    onChange={handleCategoryChange}
                                                    placeholder="Search and select categories..."
                                                    isLoading={isLoading}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" onClick={closeModal}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={modalType === 1 ? handleUpdateWorkflow : handleAddWorkflow}
                                    disabled={!workflowName || selectedCategories.length === 0}
                                >
                                    {modalType === 1 ? 'Update' : 'Add'} Workflow
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                : <></>
            }
        </>
    );
}

export default AddWorkflowModal;